import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import DistributorsList from './DistributorsList/DistributorsList';
import DistributorShow from './DistributorShow/DistributorShow';
import DistributorEdit from './DistributorEdit/DistributorEdit';
import DistributorCreate from './DistributorCreate/DistributorCreate';
import DistributorDelete from './DistributorDelete/DistributorDelete';

const Distributors = ({ match }) => {
    return (
        <div className="Distributors">
            <ContainerWrapper container="distributors">
                <Route exact path={ match.path } component={DistributorsList} />
                <Route exact path={ `${ match.url }/new` } component={DistributorCreate} />
                <Route exact path={ `${ match.url }/show/:distributorId` } component={DistributorShow} />
                <Route exact path={ `${ match.url }/edit/:distributorId` } component={DistributorEdit} />
                <Route exact path={ `${ match.url }/delete/:distributorId` } component={DistributorDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Distributors;
